
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import { Table } from '@/interfaces/models/Table';
import depositRuleHeaders from './headers';
import { DepositRule } from '@/interfaces/models/DepositRule';

@Component({
  components: { VTable },
})
export default class DepositRuleTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: DepositRule[];
  @Prop({ type: Number, required: true }) public total!: number;

  public headers: ColumnHeader[] = depositRuleHeaders;

  public edit(item: Table) {
    this.$router.push({ name: 'depositRule.edit', params: { id: item._id }, query: { ...this.$route.query } });
  }
}
